module.exports = __webpack_public_path__ + "static/media/sd.d702bafe.svg";